import {v5} from 'uuid';

const COLLAPSIBLE_UUID_NAMESPACE = 'bc5be6d7-6324-486f-8541-1fe0c214a874';
const EMPTY_COLLAPSIBLE_UUID_KEY = '_';

export function getPersistedCollapsibleStorageKey(key: string): string {
  return v5(
    key || EMPTY_COLLAPSIBLE_UUID_KEY,
    COLLAPSIBLE_UUID_NAMESPACE
  ).toString();
}
